<template>
  <div id="index">
    <!-- 导航 -->
    <!-- <div id="nav">
      <div class="nav-item" @click="changeRouter('/')">
        <img :src="imgUrlObj.homeSrc" alt="首页" />
        <p :class="imgUrlObj.navItem == 'Home' ? 'green' : ''">首页</p>
      </div>
      <div class="nav-item" @click="changeRouter('/ticket')">
        <img :src="imgUrlObj.cardSrc" alt="卡券" />
        <p :class="imgUrlObj.navItem == 'Card' ? 'green' : ''">卡券</p>
      </div>
      <div class="nav-item" @click="changeRouter('/orderList/1')">
        <img :src="imgUrlObj.orderSrc" alt="订单" />
        <p :class="imgUrlObj.navItem == 'Order' ? 'green' : ''">订单</p>
      </div>
      <div class="nav-item" @click="changeRouter('/my')">
        <img :src="imgUrlObj.mySrc" alt="我的" />
        <p :class="imgUrlObj.navItem == 'My' ? 'green' : ''">我的</p>
      </div>
    </div> -->
    <!-- 路由出口 -->
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },

  created() {
    this.setUserInfo();
  },
  methods: {
    //获取个人信息 存入vuex
    setUserInfo() {
      let userInfo = {
        memberId: this.userInfo.memberId,
      };
      this.$store.commit("setUserInfo", userInfo);
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less">
#index {
  color: #2c3e50;
  // .container {
  //  // margin-bottom: 130px;
  // }
}

#nav {
  width: 750px;
  height: 103px;
  background-color: #f7f7f7;
  position: fixed;
  bottom: 0;
  z-index: 99;
  width: 100%;
  display: flex;
  > div {
    flex: 1;
    text-align: center;
    color: #2c3e50;
    padding-top: 18px;
    img {
      width: 46px;
      height: 42px;
    }
  }
}
</style>
